import { take, fork, cancel, put, call, delay, select} from 'redux-saga/effects';
import actionTypes from '../actionTypes';
import { callApi } from "./callApi";
import { successLeaderBoard, failureLeaderBoard } from "../actionCreators/leaderboard";
import { getGlobalToken } from '../selectors';
import config from "../../config/config";

function* getLeaderBoard( { selectedPeriod, skinId } ) {
    try {
        const token = yield select(getGlobalToken);
        const res = yield call(callApi, `${config.API_URL}/club/getClubModelLeaderboard`, 'GET', {type: selectedPeriod, skinId, token });
        yield put(successLeaderBoard({leaderboard: res.data.result.players, header: res.data.result.header}));
    } catch (e) {
        yield put(failureLeaderBoard(e));
        console.log(e);
        //yield put(fillToaster(`\`${e.response.data.err.message}\` Error has occurred. Try later`, 'failure'));
    }
}

export function* watchLeaderBoard() {
    while (true) {
        const action = yield take(actionTypes.LEADERBOARD_REQUEST);
        yield fork(getLeaderBoard, action.credentials);
    }
}
